(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category_new-arrivals-carousel"] && !Shopify.designMode) return;
  try {
    
function initNewArrivalsSwiper() {
  if (typeof Swiper === 'undefined') return;

  new Swiper(".newArrivalsSwiper", {
    slidesPerView: 3,
    spaceBetween: 0,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      0: { slidesPerView: 1 },
      768: { slidesPerView: 2 },
      1200: { slidesPerView: 3 }
    }
  });
}

/* Auto-init for live and editor */
document.addEventListener('shopify:section:load', initNewArrivalsSwiper);
document.addEventListener('DOMContentLoaded', () => {
  if (typeof Swiper === 'undefined') {
    const s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
    s.onload = initNewArrivalsSwiper;
    document.head.appendChild(s);
  } else {
    initNewArrivalsSwiper();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-content-banner-badge]').forEach(function (badge) {
      var endDateStr = badge.getAttribute('data-end-date');
      var daysEl = badge.querySelector('[data-content-banner-days]');
      if (!endDateStr || !daysEl) return;

      var endDate = new Date(endDateStr + 'T23:59:59');
      if (isNaN(endDate.getTime())) return;

      var msPerDay = 1000 * 60 * 60 * 24;
      var diff = Math.ceil((endDate.getTime() - Date.now()) / msPerDay);

      if (diff < 0) {
        badge.style.display = 'none';
        return;
      }

      daysEl.textContent = diff < 10 ? '0' + diff : diff;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
